module.exports = __webpack_public_path__ + "static/welcome-bonus-1dabd3c1386a0c35dfe15355e39d597d.png";